import React, {useEffect, useState} from 'react';
import * as Icon from "ubs-icons";
import {COLOR, LIMIT} from "ubs-framework/v2/common/constant";
import Select, {components} from "react-select";
import UAvatar from "ubs-framework/v2/UAvatar";
import UAlertMessage from 'ubs-framework/v2/UAlertMessage';
import UInput from "ubs-framework/v2/UInput";
import {sendData} from "../../../../../store/actions";
import useSocket from "../../../hooks/useSocket";
import {getLabelValueUserImage, getThumbor} from "ubs-framework/v2/common/function";
import useDebouncedEffect from "use-debounced-effect";
import {useSelector} from "react-redux";

const UploadFile = React.memo((props) => {
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);

    const [isLoading, setIsLoading] = useState(false);
    const [employeeListOption, setEmployeeListOption] = useState([]);
    const [allValues, setAllValues] = useState({
        job: null,
    })

    useEffect(() => {
        sendData('ats|job|search', {})
    }, []);

    useEffect(() => {
        refresh();
        return () => off();
    }, [allValues]);

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|job|search':
                    setEmployeeListOption(getLabelValueUserImage(res?.data?.list?.filter(_ => _?.applicationField?.fields)));
                    if (res?.data?.list?.length) {
                        setAllValues({
                            ...allValues,
                            job: {
                                label: res?.data?.list[0]?.name,
                                value: res?.data?.list[0]?._id,
                                candidateIdStatus: res?.data?.list[0]?.applicationField?.fields?.find(_ => _?.value === 'candidateId')?.status
                            },
                        });
                    }
                    setIsLoading(false);
                    break
                default:
                    return true;
            }
        }
    });

    useDebouncedEffect(() => {
        if (allValues?.searchEmpText?.length >= LIMIT.SEARCH_CHARACTER) sendData('ats|job|search', {listType: 4, search: allValues?.searchEmpText})
        else setEmployeeListOption([]);
    }, LIMIT.DE_BOUNCING_TIME_OUT, [allValues?.searchEmpText]);


    const handle = {
        select: (e, key) => {
            setAllValues({...allValues, [key]: e ?? null, candidateIdStatus: e?.applicationField?.fields?.find(_ => _?.value === 'candidateId')?.status})
        },
    }

    const searchEmployee = value => {
        setAllValues({...allValues, searchEmpText: value});
        if (value?.length) setIsLoading(true);
    }

    useEffect(() => {
        if(allValues?.job?.value) {
            props.setSelectedJob({...allValues?.job, candidateIdStatus: allValues?.job?.applicationField?.fields?.find(_ => _?.value === 'candidateId')?.status || allValues?.job?.candidateIdStatus})
        }
    }, [allValues?.job])

    return (
        <React.Fragment>
            <div
                className={`u_org-dashboard u_theme u_p-20 ${props?.selectedJob?.value === undefined && 'u_event-none'}`}
                id={'import-module'} onDragEnter={(e) => props?.onDragEnter(e)}
                onDragLeave={(e) => props?.dragLeave(e)}
                onDrop={(e) => e.preventDefault()}
                onDragOver={(e) => e.preventDefault()}>
                <div
                    className={`u_upload-file u_p-15 u_flex u_align-center u_content-center u_t-center u_flex-col`} {...props?.getRootProps({onClick: e => e.stopPropagation()})}>
                    {props?.file && !props?.loader ? <div
                            className="u_upload-file-inner u_flex u_align-center u_content-center u_t-center u_flex-col">
                            <Icon.FilePreview size={56} fill={COLOR.u_blue}/>
                        </div> :
                        props?.loader ?
                            <div
                                className="u_upload-file-inner u_flex u_align-center u_content-center u_t-center u_flex-col">
                                <Icon.Preloader/>
                                <p className="u_mt-15 u_one-line">Uploading File please wait..</p>
                            </div>
                            :
                            <div
                                className="u_upload-file-inner u_flex u_align-center u_content-center u_t-center u_flex-col">
                                <Icon.Upload size={56} fill={COLOR.u_blue}/>
                                <p className="u_mt-15">Drag & Drop Resumes Here</p>
                                <p className="u_mt-15 u_mb-15">OR</p>
                                <label className="u_relative u_block u_cp">Browse File
                                    <input type="file" className="img_file_input" {...props?.getInputProps()}
                                           autoComplete="off"/>
                                </label>
                            </div>}
                    {props?.file && !props?.loader && <div className="u_choose-input u_choose-input-lable u_mt-15">
                        <div className="u_upload-file-inner">
                            <label className="u_relative u_block u_cp">Browse File
                                <input type="file" className="img_file_input" id="u_upload" {...props?.getInputProps()}
                                       autoComplete="off"/>
                            </label>
                        </div>
                    </div>}

                    <div className="u_mt-25">
                        <UInput label="Select Job" select selectValue={allValues?.job}>
                            <Select
                                name="job"
                                className="u_label-input-select-inner"
                                classNamePrefix="u_select"
                                placeholder=" "
                                isClearable={false}
                                value={allValues?.job ?? null}
                                onInputChange={searchEmployee}
                                onChange={e => handle.select(e, 'job')}
                                options={employeeListOption}
                                noOptionsMessage={() => allValues?.searchEmpText?.length < 3 ? 'Type three character to search job name.' : isLoading ? 'Loading...' : 'No Record Found'}
                                menuPosition="fixed"
                                filterOption={options => options}
                                onKeyDown={e => {
                                    if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                                }}
                                components={{
                                    Option: (props) => (
                                        <components.Option {...props}>
                                            <div className="u_filter-employee-info">
                                                <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                                         image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                                <div className="u_flex u_direction-column u_align-start">
                                                    <p className="u_one-line">{props?.data?.label}</p>
                                                    {props?.data?.jobId &&
                                                        <p className="u_color-font u_one-line">{props?.data?.jobId}</p>}
                                                </div>
                                            </div>
                                        </components.Option>
                                    ),
                                    SingleValue: (props) => (
                                        <components.SingleValue {...props}>
                                            <div className="u_filter-employee-info">
                                                <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                                         image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                                <div className="u_flex u_direction-column u_align-start">
                                                    <p className="u_one-line">{props?.data?.label}</p>
                                                    {props?.data?.jobId &&
                                                        <p className="u_color-font u_one-line">{props?.data?.jobId}</p>}
                                                </div>
                                            </div>
                                        </components.SingleValue>
                                    ),
                                }}
                            />
                        </UInput>
                    </div>

                    {props?.selectedJob?.value === undefined && <div className="u_mt-25">
                        <UAlertMessage danger full>
                            <strong>Note: </strong>
                            <span>At least one Job is require to upload resume</span>
                        </UAlertMessage>
                    </div>}
                </div>
                <p className="u_pt-10">
                    <strong className="u_task-darkname">Note: </strong>
                    To generate candidate IDs in Recruit, enable manual setting of Candidate Id in settings. Make candidate ID mandatory/optional in job application field. This ensures software generates candidate IDs and collects required information.
                </p>
            </div>
        </React.Fragment>
    );
});

export default UploadFile;
